export default __webpack_public_path__ + "static/media/outdoor-3.48d4f97c.png";